import React, { ReactNode } from 'react';

import { useSelector } from 'react-redux';

import { SourceViewLink } from 'src/components/diff-set/components/source-view-link';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import urls from 'src/urls/source';

type Props = {
  children: ReactNode;
  filepath: string;
  sourceHash: string;
  destinationHash?: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const SourceDiffLink: React.FC<Props> = ({
  children,
  filepath,
  sourceHash,
  destinationHash,
}) => {
  // Code Review and Source have opposite concepts of source/destination
  const spec = {
    source: destinationHash,
    destination: sourceHash,
  };

  const repositoryFullSlug = useSelector(getCurrentRepositoryFullSlug) || '';

  const viewHref = urls.ui.diff(repositoryFullSlug, filepath, spec);

  return (
    <SourceViewLink viewHref={viewHref} target="_blank">
      {children}
    </SourceViewLink>
  );
};
